import React from 'react';
import { AirVentIcon, ThermometerIcon, WrenchIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
const ServicesPage = () => {
  const services = [{
    id: 'fire-protection',
    title: 'Fire Protection Systems',
    icon: <div size={32} data-id="element-670" />,
    description: 'We supply, install, and maintain comprehensive fire protection systems for commercial and industrial facilities. Our services include fire-fighting pumps, sprinkler systems, hydrants, and specialized fire suppression equipment designed to protect your assets and ensure compliance with safety regulations.',
    features: ['Fire pump installation and maintenance', 'Sprinkler system design and installation', 'Fire hydrant networks', 'Fire suppression systems for specialized environments', 'Regular testing and certification', 'Emergency repair services'],
    image: 'https://images.unsplash.com/photo-1599909366881-7c9bc6e548e7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
  }, {
    id: 'underground-leakage',
    title: 'Underground Leakage Control & Piping Works',
    icon: <div size={32} data-id="element-671" />,
    description: 'Our underground leakage control services help detect, repair, and replace underground water and gas pipelines. Using advanced detection technology, we identify leaks with minimal disruption, ensuring efficient and safe operation of your underground utility systems.',
    features: ['Non-destructive leak detection', 'Pipeline replacement and repair', 'Trenchless technology solutions', 'Pressure testing and system certification', 'Preventive maintenance programs', 'Emergency response for critical leaks'],
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/dFbZ7TfA7BeXxibRpzWd7c/IMG-20250828-WA0022.jpg'
  }, {
    id: 'compressed-air',
    title: 'Compressed Air Systems',
    icon: <AirVentIcon size={32} data-id="element-672" />,
    description: 'We design, assemble, and install compressor systems for industrial and commercial applications. Our compressed air solutions are engineered for reliability, energy efficiency, and performance, backed by comprehensive maintenance services to ensure continuous operation.',
    features: ['Compressor system design and installation', 'Air treatment and filtration', 'Distribution network installation', 'Energy efficiency audits and optimization', 'Preventive maintenance programs', 'Emergency repair services'],
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3hTgHUcfHSQHoQfP4YQjDw/IMG-20250828-WA0025.jpg'
  }, {
    id: 'hvac-chiller',
    title: 'HVAC & Chiller Systems',
    icon: <ThermometerIcon size={32} data-id="element-673" />,
    description: 'Our HVAC and chiller system services cover installation, maintenance, and repair of cooling towers, air conditioning systems, and industrial cooling solutions. We ensure optimal climate control and energy efficiency for commercial and industrial facilities.',
    features: ['Chiller tower installation and servicing', 'Commercial HVAC system design and installation', 'Industrial cooling solutions', 'Energy efficiency optimization', 'Preventive maintenance programs', '24/7 emergency repair services'],
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/q9Rzyr8MSfeD8mb3Xz6E1b/IMG-20250828-WA0026.jpg'
  }, {
    id: 'diesel-pump',
    title: 'Diesel Pump Engines & Power Systems',
    icon: <div size={32} data-id="element-674" />,
    description: 'We specialize in the installation, repair, and maintenance of diesel pump engines used in water systems, fire protection, and industrial processes. Our services ensure reliable power for critical systems and include comprehensive preventive maintenance programs.',
    features: ['Diesel pump engine installation', 'Performance testing and optimization', 'Fuel system maintenance', 'Cooling system servicing', 'Scheduled preventive maintenance', 'Emergency repair and parts replacement'],
    image: 'https://images.unsplash.com/photo-1589939705384-5185137a7f0f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
  }, {
    id: 'plumbing',
    title: 'Plumbing & Mechanical Installations',
    icon: <WrenchIcon size={32} data-id="element-675" />,
    description: 'Our plumbing and mechanical installation services cover general plumbing, water reticulation systems, and industrial mechanical works. From design to installation and maintenance, we provide comprehensive solutions for residential, commercial, and industrial clients.',
    features: ['Commercial and industrial plumbing systems', 'Water reticulation network design and installation', 'Mechanical equipment installation', 'Water treatment systems', 'Scheduled maintenance programs', 'Emergency repair services'],
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gj59xh5o8FP3M5iDrq1yB2/IMG-20250828-WA0023.jpg'
  }, {
    id: 'oil-gas',
    title: 'Oil & Gas Mechanical Services',
    icon: <div size={32} data-id="element-676" />,
    description: 'We provide specialized services for the installation, inspection, and maintenance of oil and gas handling systems. Our team ensures compliance with industry standards and regulations while delivering safe and efficient solutions for this critical sector.',
    features: ['Pipeline installation and maintenance', 'Pump and compressor installation', 'Storage tank installation and servicing', 'Pressure vessel inspection and certification', 'Compliance with industry regulations', 'Emergency response services'],
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sxZnRZGbG5p2zjUJbrwqXT/IMG-20250828-WA0024.jpg'
  }];
  return <div className="w-full" data-id="element-677">
      {/* Hero Section */}
      <section className="relative bg-gray-900 text-white py-24" data-id="element-678">
        <div className="absolute inset-0 bg-black opacity-60" data-id="element-679"></div>
        <div className="absolute inset-0 bg-cover bg-center" style={{
        backgroundImage: "url('https://uploadthingy.s3.us-west-1.amazonaws.com/3hTgHUcfHSQHoQfP4YQjDw/IMG-20250828-WA0025.jpg')",
        backgroundBlendMode: 'overlay'
      }} data-id="element-680"></div>
        <div className="container mx-auto px-4 relative z-10 text-center" data-id="element-681">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-682">Our Services</h1>
          <p className="text-xl max-w-3xl mx-auto" data-id="element-683">
            Comprehensive engineering solutions for all your mechanical,
            plumbing, and industrial system needs.
          </p>
        </div>
      </section>
      {/* Services Overview */}
      <section className="py-16" data-id="element-684">
        <div className="container mx-auto px-4" data-id="element-685">
          <div className="text-center mb-12" data-id="element-686">
            <h2 className="text-3xl font-bold mb-4" data-id="element-687">
              <span className="border-b-4 border-red-600 pb-2" data-id="element-688">
                Comprehensive
              </span>{' '}
              Engineering Solutions
            </h2>
            <p className="text-gray-600 max-w-3xl mx-auto" data-id="element-689">
              At Daplamba Investments Limited, we offer a wide range of
              technical mechanical services to meet the diverse needs of our
              clients across Uganda and East Africa. Our team of experienced
              engineers and technicians delivers quality solutions for both
              domestic and industrial applications.
            </p>
          </div>
          {/* Service List */}
          <div className="space-y-24" data-id="element-690">
            {services.map((service, index) => <motion.div key={service.id} id={service.id} className={`flex flex-col ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} items-center`} initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-691">
                <div className="md:w-1/2 mb-8 md:mb-0 md:px-8" data-id="element-692">
                  <div className="bg-red-600 text-white p-3 rounded-full w-16 h-16 flex items-center justify-center mb-4" data-id="element-693">
                    {service.icon}
                  </div>
                  <h3 className="text-2xl font-bold mb-4" data-id="element-694">{service.title}</h3>
                  <p className="text-gray-700 mb-6" data-id="element-695">{service.description}</p>
                  <h4 className="font-bold text-lg mb-3" data-id="element-696">Key Features:</h4>
                  <ul className="space-y-2 mb-6" data-id="element-697">
                    {service.features.map((feature, i) => <li key={i} className="flex items-start" data-id="element-698">
                        <span className="text-red-600 mr-2" data-id="element-699">•</span>
                        <span data-id="element-700">{feature}</span>
                      </li>)}
                  </ul>
                </div>
                <motion.div className="md:w-1/2" whileHover={{
              scale: 1.02
            }} transition={{
              duration: 0.3
            }} data-id="element-701">
                  <img src={service.image} alt={service.title} className="rounded-lg shadow-lg w-full h-80 object-cover" data-id="element-702" />
                </motion.div>
              </motion.div>)}
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16 bg-gray-900 text-white" data-id="element-703">
        <div className="container mx-auto px-4 text-center" data-id="element-704">
          <h2 className="text-3xl font-bold mb-6" data-id="element-705">
            Need a Custom Engineering Solution?
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto" data-id="element-706">
            Our team of experts is ready to design a tailored solution for your
            specific needs. Contact us today to discuss your project
            requirements.
          </p>
          <motion.div whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} data-id="element-707">
            <Link to="/contact" className="bg-red-600 hover:bg-red-700 text-white px-8 py-3 rounded-md font-medium transition-colors inline-block" data-id="element-708">
              Request a Consultation
            </Link>
          </motion.div>
        </div>
      </section>
    </div>;
};
export default ServicesPage;